import { render } from "./HeightAndWeightFields.vue?vue&type=template&id=7d67083f&scoped=true"
import script from "./HeightAndWeightFields.vue?vue&type=script&lang=js"
export * from "./HeightAndWeightFields.vue?vue&type=script&lang=js"

import "./HeightAndWeightFields.vue?vue&type=style&index=0&id=7d67083f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d67083f"]])

export default __exports__